// src/components/ModalRestriccionServiciosMora.js
import React, { useState } from 'react';
import {
    FaUsers,
    FaSwimmingPool,
    FaShieldAlt,
    FaFileInvoiceDollar,
    FaTimes,
    FaLock,
    FaInfoCircle,
    FaBullhorn,
    FaCalendarAlt,
    FaHandsHelping,
    FaRocketchat,
    FaFileAlt,
    FaUserEdit,
    FaQrcode,
    FaBoxOpen,
    FaClock,
    FaCheckCircle
} from 'react-icons/fa';
import './ModalRestriccionServiciosMora.css';

export const DEFAULT_RESTRICCIONES_DETALLE = {
    comunidad: {
        bloqueoTotal: false,
        subsecciones: {
            votaciones_avisos: false,
            propuestas_incidencias: false,
            eventos_citas: false,
            chat_comunitario: false,
            solicitudes_permisos: false,
            directorio_contactos: false
        }
    },
    amenidades: {
        bloqueoTotal: false,
        subsecciones: {
            reservar_amenidades: false,
            calendario_disponibilidad: false,
            mis_reservas: false
        }
    },
    vigilancia: {
        bloqueoTotal: false,
        subsecciones: {
            generar_qr: false,
            mis_invitaciones: false,
            paqueteria: false,
            visitas_frecuentes: false
        }
    },
    finanzas: {
        mostrarModalAviso: true
    }
};

const ModalRestriccionServiciosMora = ({
    isOpen,
    onClose,
    initialDetalle,
    initialMeses,
    onApply
}) => {
    const [activeTab, setActiveTab] = useState('comunidad');
    const [meses, setMeses] = useState(
        initialMeses !== undefined && initialMeses !== null && initialMeses !== ''
            ? String(initialMeses)
            : '0'
    );

    const [detalle, setDetalle] = useState(() => {
        const merged = JSON.parse(JSON.stringify(DEFAULT_RESTRICCIONES_DETALLE));
        if (initialDetalle && typeof initialDetalle === 'object') {
            if (initialDetalle.comunidad) {
                merged.comunidad.bloqueoTotal = Boolean(initialDetalle.comunidad.bloqueoTotal);
                if (initialDetalle.comunidad.subsecciones) {
                    merged.comunidad.subsecciones = {
                        ...merged.comunidad.subsecciones,
                        ...initialDetalle.comunidad.subsecciones
                    };
                }
            }
            if (initialDetalle.amenidades) {
                merged.amenidades.bloqueoTotal = Boolean(initialDetalle.amenidades.bloqueoTotal);
                if (initialDetalle.amenidades.subsecciones) {
                    merged.amenidades.subsecciones = {
                        ...merged.amenidades.subsecciones,
                        ...initialDetalle.amenidades.subsecciones
                    };
                }
            }
            if (initialDetalle.vigilancia) {
                merged.vigilancia.bloqueoTotal = Boolean(initialDetalle.vigilancia.bloqueoTotal);
                if (initialDetalle.vigilancia.subsecciones) {
                    merged.vigilancia.subsecciones = {
                        ...merged.vigilancia.subsecciones,
                        ...initialDetalle.vigilancia.subsecciones
                    };
                }
            }
            if (initialDetalle.finanzas) {
                merged.finanzas.mostrarModalAviso = initialDetalle.finanzas.mostrarModalAviso !== undefined
                    ? Boolean(initialDetalle.finanzas.mostrarModalAviso)
                    : true;
            }
        }
        return merged;
    });

    if (!isOpen) return null;

    const handleToggleMaster = (tabKey, value) => {
        setDetalle(prev => ({
            ...prev,
            [tabKey]: {
                ...prev[tabKey],
                bloqueoTotal: value
            }
        }));
    };

    const handleToggleSubseccion = (tabKey, subKey, value) => {
        setDetalle(prev => ({
            ...prev,
            [tabKey]: {
                ...prev[tabKey],
                subsecciones: {
                    ...prev[tabKey]?.subsecciones,
                    [subKey]: value
                }
            }
        }));
    };

    const handleSave = () => {
        // Construir lista sincronizada para retrocompatibilidad
        const legacyList = [];
        if (detalle.comunidad.bloqueoTotal || detalle.comunidad.subsecciones.chat_comunitario) {
            legacyList.push('chat');
        }
        if (detalle.comunidad.bloqueoTotal || detalle.comunidad.subsecciones.solicitudes_permisos) {
            legacyList.push('solicitudes');
        }
        if (detalle.comunidad.bloqueoTotal || detalle.comunidad.subsecciones.directorio_contactos) {
            legacyList.push('datosContacto');
        }
        if (detalle.amenidades.bloqueoTotal || detalle.amenidades.subsecciones.reservar_amenidades) {
            legacyList.push('amenidades');
        }
        if (detalle.vigilancia.bloqueoTotal || detalle.vigilancia.subsecciones.generar_qr) {
            legacyList.push('visitas');
        }

        const parsedMeses = parseInt(meses, 10);
        const finalMeses = isNaN(parsedMeses) || parsedMeses < 0 ? 0 : parsedMeses;

        onApply({
            restriccionesDetalle: detalle,
            restriccionMeses: finalMeses,
            restriccionServicios: legacyList
        });
        onClose();
    };

    // Conteo de bloqueos para badges de pestañas
    const countComunidad = (detalle.comunidad.bloqueoTotal ? 1 : 0) +
        Object.values(detalle.comunidad.subsecciones || {}).filter(Boolean).length;
    const countAmenidades = (detalle.amenidades.bloqueoTotal ? 1 : 0) +
        Object.values(detalle.amenidades.subsecciones || {}).filter(Boolean).length;
    const countVigilancia = (detalle.vigilancia.bloqueoTotal ? 1 : 0) +
        Object.values(detalle.vigilancia.subsecciones || {}).filter(Boolean).length;

    return (
        <div className="modal-restricciones-backdrop" onClick={onClose}>
            <div className="modal-restricciones-card" onClick={e => e.stopPropagation()}>
                {/* Header */}
                <div className="modal-restricciones-header">
                    <div className="modal-restricciones-header-title">
                        <div className="icon-lock-header">
                            <FaLock />
                        </div>
                        <div>
                            <h3>Configuración de Restricción de Servicios por Mora</h3>
                            <p>Inhabilita pestañas completas o funciones específicas a residentes en estado moroso.</p>
                        </div>
                    </div>
                    <button className="modal-restricciones-btn-close" onClick={onClose} aria-label="Cerrar">
                        <FaTimes />
                    </button>
                </div>

                {/* Barra de Umbral de Meses */}
                <div className="modal-restricciones-threshold-bar">
                    <div className="threshold-info">
                        <label>Meses de deuda para aplicar restricción</label>
                        <span>Con 0 meses, las restricciones se activan de inmediato con cualquier adeudo (&ge; $1.00).</span>
                    </div>
                    <div className="threshold-input-wrapper">
                        <input
                            type="number"
                            min="0"
                            max="12"
                            value={meses}
                            onChange={e => setMeses(e.target.value)}
                        />
                        <span className="threshold-unit">mes(es)</span>
                    </div>
                </div>

                {/* Navegación por Pestañas */}
                <div className="modal-restricciones-tabs">
                    <button
                        type="button"
                        className={`modal-restricciones-tab-btn ${activeTab === 'comunidad' ? 'active' : ''}`}
                        onClick={() => setActiveTab('comunidad')}
                    >
                        <FaUsers /> Comunidad
                        {countComunidad > 0 && <span className="tab-badge-lock">{countComunidad}</span>}
                    </button>
                    <button
                        type="button"
                        className={`modal-restricciones-tab-btn ${activeTab === 'amenidades' ? 'active' : ''}`}
                        onClick={() => setActiveTab('amenidades')}
                    >
                        <FaSwimmingPool /> Amenidades
                        {countAmenidades > 0 && <span className="tab-badge-lock">{countAmenidades}</span>}
                    </button>
                    <button
                        type="button"
                        className={`modal-restricciones-tab-btn ${activeTab === 'vigilancia' ? 'active' : ''}`}
                        onClick={() => setActiveTab('vigilancia')}
                    >
                        <FaShieldAlt /> Vigilancia
                        {countVigilancia > 0 && <span className="tab-badge-lock">{countVigilancia}</span>}
                    </button>
                    <button
                        type="button"
                        className={`modal-restricciones-tab-btn ${activeTab === 'finanzas' ? 'active' : ''}`}
                        onClick={() => setActiveTab('finanzas')}
                    >
                        <FaFileInvoiceDollar /> Finanzas
                        {detalle.finanzas.mostrarModalAviso && <span className="tab-badge-lock" style={{ background: '#e0f2fe', color: '#0284c7' }}>Aviso</span>}
                    </button>
                </div>

                {/* Contenido de la Pestaña Activa */}
                <div className="modal-restricciones-body">
                    {/* 1. COMUNIDAD */}
                    {activeTab === 'comunidad' && (
                        <div>
                            {/* Toggle Maestro */}
                            <div className={`restricciones-master-card ${detalle.comunidad.bloqueoTotal ? 'active-blocked' : ''}`}>
                                <div className="master-card-info">
                                    <h4>Bloquear pestaña de Comunidad completa</h4>
                                    <p>Inhabilita todo el acceso a la sección de Comunidad para residentes morosos.</p>
                                </div>
                                <label className="switch-zen">
                                    <input
                                        type="checkbox"
                                        checked={detalle.comunidad.bloqueoTotal}
                                        onChange={e => handleToggleMaster('comunidad', e.target.checked)}
                                    />
                                    <span className="slider-zen" />
                                </label>
                            </div>

                            <div className="restricciones-subsections-title">
                                {detalle.comunidad.bloqueoTotal
                                    ? 'Subsecciones bloqueadas automáticamente por el toggle maestro:'
                                    : 'Mini-toggles por subsección (bloqueo selectivo):'}
                            </div>

                            <div className="restricciones-subsections-grid">
                                {[
                                    { key: 'votaciones_avisos', label: 'Votaciones y Avisos', icon: <FaBullhorn /> },
                                    { key: 'propuestas_incidencias', label: 'Propuestas e Incidencias', icon: <FaHandsHelping /> },
                                    { key: 'eventos_citas', label: 'Eventos y Citas', icon: <FaCalendarAlt /> },
                                    { key: 'chat_comunitario', label: 'Chat Comunitario', icon: <FaRocketchat /> },
                                    { key: 'solicitudes_permisos', label: 'Solicitudes y Permisos', icon: <FaFileAlt /> },
                                    { key: 'directorio_contactos', label: 'Directorio de Contactos', icon: <FaUserEdit /> },
                                ].map(item => {
                                    const isBlocked = detalle.comunidad.bloqueoTotal || Boolean(detalle.comunidad.subsecciones?.[item.key]);
                                    return (
                                        <div
                                            key={item.key}
                                            className={`subtoggle-item ${isBlocked ? 'is-blocked' : ''} ${detalle.comunidad.bloqueoTotal ? 'is-parent-locked' : ''}`}
                                        >
                                            <div className="subtoggle-label-wrapper">
                                                <div className="subtoggle-icon">{item.icon}</div>
                                                <span>{item.label}</span>
                                            </div>
                                            <label className="switch-zen">
                                                <input
                                                    type="checkbox"
                                                    disabled={detalle.comunidad.bloqueoTotal}
                                                    checked={isBlocked}
                                                    onChange={e => handleToggleSubseccion('comunidad', item.key, e.target.checked)}
                                                />
                                                <span className="slider-zen" />
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* 2. AMENIDADES */}
                    {activeTab === 'amenidades' && (
                        <div>
                            {/* Toggle Maestro */}
                            <div className={`restricciones-master-card ${detalle.amenidades.bloqueoTotal ? 'active-blocked' : ''}`}>
                                <div className="master-card-info">
                                    <h4>Bloquear pestaña de Amenidades completa</h4>
                                    <p>Impide el acceso general a amenidades a los residentes en estado moroso.</p>
                                </div>
                                <label className="switch-zen">
                                    <input
                                        type="checkbox"
                                        checked={detalle.amenidades.bloqueoTotal}
                                        onChange={e => handleToggleMaster('amenidades', e.target.checked)}
                                    />
                                    <span className="slider-zen" />
                                </label>
                            </div>

                            <div className="restricciones-subsections-title">
                                {detalle.amenidades.bloqueoTotal
                                    ? 'Funciones bloqueadas automáticamente por el toggle maestro:'
                                    : 'Mini-toggles por función (bloqueo selectivo):'}
                            </div>

                            <div className="restricciones-subsections-grid">
                                {[
                                    { key: 'reservar_amenidades', label: 'Reservar Amenidades', icon: <FaSwimmingPool /> },
                                    { key: 'calendario_disponibilidad', label: 'Calendario y Disponibilidad', icon: <FaCalendarAlt /> },
                                    { key: 'mis_reservas', label: 'Mis Reservas Activas', icon: <FaClock /> },
                                ].map(item => {
                                    const isBlocked = detalle.amenidades.bloqueoTotal || Boolean(detalle.amenidades.subsecciones?.[item.key]);
                                    return (
                                        <div
                                            key={item.key}
                                            className={`subtoggle-item ${isBlocked ? 'is-blocked' : ''} ${detalle.amenidades.bloqueoTotal ? 'is-parent-locked' : ''}`}
                                        >
                                            <div className="subtoggle-label-wrapper">
                                                <div className="subtoggle-icon">{item.icon}</div>
                                                <span>{item.label}</span>
                                            </div>
                                            <label className="switch-zen">
                                                <input
                                                    type="checkbox"
                                                    disabled={detalle.amenidades.bloqueoTotal}
                                                    checked={isBlocked}
                                                    onChange={e => handleToggleSubseccion('amenidades', item.key, e.target.checked)}
                                                />
                                                <span className="slider-zen" />
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* 3. VIGILANCIA */}
                    {activeTab === 'vigilancia' && (
                        <div>
                            {/* Toggle Maestro */}
                            <div className={`restricciones-master-card ${detalle.vigilancia.bloqueoTotal ? 'active-blocked' : ''}`}>
                                <div className="master-card-info">
                                    <h4>Bloquear pestaña de Vigilancia completa</h4>
                                    <p>Inhabilita el acceso total al módulo de Vigilancia para el residente moroso.</p>
                                </div>
                                <label className="switch-zen">
                                    <input
                                        type="checkbox"
                                        checked={detalle.vigilancia.bloqueoTotal}
                                        onChange={e => handleToggleMaster('vigilancia', e.target.checked)}
                                    />
                                    <span className="slider-zen" />
                                </label>
                            </div>

                            <div className="restricciones-subsections-title">
                                {detalle.vigilancia.bloqueoTotal
                                    ? 'Funciones bloqueadas automáticamente por el toggle maestro:'
                                    : 'Mini-toggles por función de vigilancia (bloqueo selectivo):'}
                            </div>

                            <div className="restricciones-subsections-grid">
                                {[
                                    { key: 'generar_qr', label: 'Generar QR para Invitado', icon: <FaQrcode /> },
                                    { key: 'mis_invitaciones', label: 'Mis Invitaciones QR', icon: <FaCheckCircle /> },
                                    { key: 'paqueteria', label: 'Paquetería y Entregas', icon: <FaBoxOpen /> },
                                    { key: 'visitas_frecuentes', label: 'Visitas Frecuentes', icon: <FaUsers /> },
                                ].map(item => {
                                    const isBlocked = detalle.vigilancia.bloqueoTotal || Boolean(detalle.vigilancia.subsecciones?.[item.key]);
                                    return (
                                        <div
                                            key={item.key}
                                            className={`subtoggle-item ${isBlocked ? 'is-blocked' : ''} ${detalle.vigilancia.bloqueoTotal ? 'is-parent-locked' : ''}`}
                                        >
                                            <div className="subtoggle-label-wrapper">
                                                <div className="subtoggle-icon">{item.icon}</div>
                                                <span>{item.label}</span>
                                            </div>
                                            <label className="switch-zen">
                                                <input
                                                    type="checkbox"
                                                    disabled={detalle.vigilancia.bloqueoTotal}
                                                    checked={isBlocked}
                                                    onChange={e => handleToggleSubseccion('vigilancia', item.key, e.target.checked)}
                                                />
                                                <span className="slider-zen" />
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* 4. FINANZAS */}
                    {activeTab === 'finanzas' && (
                        <div>
                            {/* Tarjeta explicativa de exclusión de bloqueo */}
                            <div className="restricciones-info-card">
                                <div className="info-card-icon">
                                    <FaInfoCircle />
                                </div>
                                <div className="info-card-content">
                                    <h4>Pestaña Excluida de Bloqueo de Acceso</h4>
                                    <p>
                                        Finanzas permanece accesible para los residentes morosos para que puedan consultar
                                        su estado de cuenta, revisar los conceptos adeudados y realizar su liquidación.
                                    </p>
                                </div>
                            </div>

                            {/* Toggle de Aviso Emergente Cordial */}
                            <div className="restricciones-master-card" style={{ background: '#f0fdf4', borderColor: '#bbf7d0' }}>
                                <div className="master-card-info">
                                    <h4>Mostrar aviso cordial de pago al ingresar</h4>
                                    <p>
                                        Despliega una ventana emergente sutil invitando al residente a liquidar su adeudo
                                        cada vez que navegue a Finanzas, la cual debe confirmar presionando "Entendido / Informado".
                                    </p>
                                </div>
                                <label className="switch-zen switch-blue">
                                    <input
                                        type="checkbox"
                                        checked={Boolean(detalle.finanzas?.mostrarModalAviso)}
                                        onChange={e => {
                                            const val = e.target.checked;
                                            setDetalle(prev => ({
                                                ...prev,
                                                finanzas: {
                                                    ...prev.finanzas,
                                                    mostrarModalAviso: val
                                                }
                                            }));
                                        }}
                                    />
                                    <span className="slider-zen" />
                                </label>
                            </div>
                        </div>
                    )}
                </div>

                {/* Footer de Acciones */}
                <div className="modal-restricciones-footer">
                    <button type="button" className="btn-cancel" onClick={onClose}>
                        Cancelar
                    </button>
                    <button type="button" className="btn-save" onClick={handleSave}>
                        Aplicar Configuración
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalRestriccionServiciosMora;
